import { FC, PropsWithChildren } from 'react'

import { Skeleton, useTheme } from '@mui/material'
import { DataCardSkeleton } from '@/components/card/DataCard/DataCardSkeleton'

const SKELETON_TEST_ID = 'statistics-card-skeleton' as const

type Props = PropsWithChildren & { height: number; testId?: string }

export const StatisticsCardSkeleton: FC<Props> = ({ children, height, testId }) => {
  const theme = useTheme()

  return (
    <DataCardSkeleton
      testId={testId || SKELETON_TEST_ID}
      Sx={{
        card: {
          boxShadow: 'none'
        },
        header: {
          backgroundColor: theme.palette.statistics.panel.header.backgroundColor
        }
      }}
      headerPostfixActions={
        <Skeleton
          variant="rounded"
          width={30}
          height={30}
          sx={{
            borderRadius: 10
          }}
        />
      }
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height={height}
        sx={{
          borderRadius: Number(theme.shape.borderRadius) / 2,
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0
        }}
      />
      {children}
    </DataCardSkeleton>
  )
}
